const updatePageTitle = publication => {
    let title = 'Dimensions';

    if (publication) {
        title = title + ' – ' + publication.title;
    } else {
        title = title + ' – page not found';
    }

    window.document.title = title;
};

const canonicalURL = (rootURL, publication) => {
    return `${rootURL}/details/id/${publication.id}`;
};

const updateCanonicalURL = (rootURL, publication) => {
    if (!publication) return;

    const canonical = canonicalURL(rootURL, publication);

    try {
        window.history.replaceState({}, null, canonical);
    } catch (e) {
        // Don't fail if the history API is unavailable
    }

    const canonicalTag = document.createElement('link');
    canonicalTag.setAttribute('rel', 'canonical');
    canonicalTag.setAttribute('href', canonical);

    document.getElementsByTagName('head')[0].appendChild(canonicalTag);
};

export default {
    updatePageTitle,
    canonicalURL,
    updateCanonicalURL
};
